(() => {
  const labels = document.querySelector('#roscoff-video-labels')?.dataset;
  if (!labels) return;
  const players = [...document.querySelectorAll('.home-video-launch, .video-launch')].map(launch => {
    const id = launch.dataset.youtubeId;
    const host = launch.closest('.film-media, .film-image');
    if (!/^[\w-]{11}$/.test(id || '') || !host) return null;
    const player = {
      host, id, title: launch.dataset.videoTitle || launch.getAttribute('aria-label'),
      poster: launch.dataset.videoPoster || launch.querySelector('img')?.src,
      start: Math.max(0, parseInt(launch.dataset.youtubeStart || '0', 10) || 0),
      frame: null
    };
    host.classList.add('roscoff-video-host');
    player.actions = document.createElement('div');
    player.actions.className = 'roscoff-video-actions';
    player.actions.hidden = true;
    const block = document.createElement('div');
    block.className = 'roscoff-video-block';
    host.before(block);
    block.append(host, player.actions);
    return player;
  }).filter(Boolean);
  if (!players.length) return;

  const externalLink = player => {
    const link = document.createElement('a');
    const url = new URL('https://www.youtube.com/watch');
    url.searchParams.set('v', player.id);
    if (player.start) url.searchParams.set('t', `${player.start}s`);
    link.href = url.href;
    link.target = '_blank';
    link.rel = 'noopener noreferrer';
    link.textContent = labels.external;
    return link;
  };
  const poster = player => {
    player.frame = null;
    player.host.replaceChildren();
    player.actions.replaceChildren();
    player.actions.hidden = true;
    const image = document.createElement('img');
    image.className = 'roscoff-video-poster';
    image.src = player.poster;
    image.alt = player.title;
    image.width = 1280;
    image.height = 720;
    image.loading = 'lazy';
    const play = document.createElement('button');
    play.type = 'button';
    play.className = 'roscoff-video-play-button';
    play.setAttribute('aria-label', `${labels.play} sur YouTube : ${player.title}`);
    const icon = document.createElement('span');
    icon.setAttribute('aria-hidden', 'true');
    play.append(icon);
    play.addEventListener('click', () => start(player));
    player.host.append(image, play);
    player.play = play;
  };

  // No request to YouTube occurs until the visitor asks to view this film.
  // The global Shopify privacy preferences are never changed by this control.
  const start = player => {
    const frame = document.createElement('iframe');
    const url = new URL(`https://www.youtube-nocookie.com/embed/${player.id}`);
    url.searchParams.set('autoplay', '0');
    url.searchParams.set('playsinline', '1');
    url.searchParams.set('rel', '0');
    if (player.start) url.searchParams.set('start', String(player.start));
    frame.src = url.href;
    frame.title = player.title;
    frame.loading = 'eager';
    frame.allow = 'autoplay; encrypted-media; picture-in-picture; fullscreen';
    frame.allowFullscreen = true;
    frame.referrerPolicy = 'strict-origin-when-cross-origin';
    const loading = document.createElement('p');
    loading.className = 'roscoff-video-loading';
    loading.textContent = labels.loading;
    loading.setAttribute('role', 'status');
    frame.addEventListener('load', () => loading.remove(), {once: true});
    player.host.replaceChildren(frame, loading);
    player.frame = frame;
    const close = document.createElement('button');
    close.type = 'button';
    close.textContent = labels.revoke;
    close.addEventListener('click', () => { poster(player); player.play.focus(); });
    player.actions.replaceChildren(close, externalLink(player));
    player.actions.hidden = false;
  };

  players.forEach(poster);
})();
